/* src/app/components/elibraryandcourse/e-library/e-library-details/e-library-upload/e-library-upload.component.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 0;
}
.library-upload-view {
  --primary: #253b80;
  --primary-dark: #1d2f68;
  --primary-soft: #eef2ff;
  --text: #172033;
  --text-muted: #667085;
  --text-light: #98a2b3;
  --border: #e4e7ec;
  --border-light: #eaecf0;
  --surface: #fff;
  --surface-soft: #f8fafc;
  --background: #f4f6fa;
  --success: #12b76a;
  --danger: #f04438;
  --radius: 14px;
  --radius-sm: 10px;
  width: 100%;
  height: 100%;
  min-height: 0;
  background: var(--background);
  box-sizing: border-box;
}
.library-upload-view *,
.library-upload-view *::before,
.library-upload-view *::after {
  box-sizing: border-box;
}
.library-upload-view {
}
.library-upload-view .flex-container,
.library-upload-view .flex-item {
  width: 100%;
  height: 100%;
  min-height: 0;
}
.library-upload-view .card {
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: var(--surface);
  border: 1px solid var(--border-light);
  border-radius: var(--radius);
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.04), 0 8px 24px rgba(16, 24, 40, 0.05);
  overflow: hidden;
}
.library-upload-view {
}
.library-upload-view .questionariesTab {
  flex: 0 0 auto;
  margin: 0;
  padding: 20px 28px;
  background: #fff;
  border-bottom: 1px solid var(--border-light);
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.library-upload-view .questionariesTab::-webkit-scrollbar {
  height: 5px;
}
.library-upload-view .questionariesTab::-webkit-scrollbar-track {
  background: transparent;
}
.library-upload-view .questionariesTab::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 20px;
}
.library-upload-view .questionariesTab ul {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  min-width: 760px;
  margin: 0;
  padding: 0;
  list-style: none;
  border: 0;
}
.library-upload-view .questionariesTab .tab {
  position: relative;
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 145px;
  padding: 0 20px;
  border: 0 !important;
  color: var(--text-muted);
  cursor: pointer;
  transition: color 0.2s ease, transform 0.2s ease;
}
.library-upload-view .questionariesTab .tab > span:first-child {
  position: relative;
  z-index: 2;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid #d0d5dd;
  border-radius: 50%;
  background: #fff;
  font-size: 13px;
  font-weight: 700;
  transition: all 0.25s ease;
}
.library-upload-view .questionariesTab .tab a {
  padding: 0 !important;
  color: inherit;
  background: transparent !important;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}
.library-upload-view .questionariesTab .tab .edit,
.library-upload-view .questionariesTab .tab .check-mark {
  display: none;
}
.library-upload-view .questionariesTab .tab .line-horizontal {
  position: absolute;
  top: 17px;
  left: calc(100% - 4px);
  width: 45px;
  height: 1px;
  background: #e4e7ec;
}
.library-upload-view .questionariesTab .tab:last-child .line-horizontal {
  display: none;
}
.library-upload-view .questionariesTab .tab:hover {
  color: var(--primary);
}
.library-upload-view .questionariesTab .tab:hover > span:first-child {
  border-color: var(--primary);
}
.library-upload-view .questionariesTab .tab.is-active {
  color: var(--primary);
}
.library-upload-view .questionariesTab .tab.is-active > span:first-child {
  border-color: var(--primary);
  background: var(--primary);
  color: #fff;
  box-shadow: 0 0 0 5px var(--primary-soft);
}
.library-upload-view .questionariesTab .tab.complete {
  color: var(--success);
}
.library-upload-view .questionariesTab .tab.complete > span:first-child {
  border-color: var(--success);
  background: var(--success);
  color: transparent;
}
.library-upload-view .questionariesTab .tab.complete .check-mark {
  position: absolute;
  left: 30px;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  z-index: 3;
}
.library-upload-view .questionariesTab .tab.complete .check-mark i {
  font-size: 10px;
}
.library-upload-view .questionariesTab .tab.complete .line-horizontal {
  background: var(--success);
}
.library-upload-view {
}
.library-upload-view .card-body {
  flex: 1 1 auto;
  min-height: 0;
  height: calc(100vh - 290px);
  padding: 0 !important;
  overflow: hidden auto;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.library-upload-view .card-body::-webkit-scrollbar {
  width: 7px;
}
.library-upload-view .card-body::-webkit-scrollbar-track {
  background: transparent;
}
.library-upload-view .card-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 20px;
}
.library-upload-view .card-body::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.library-upload-view .card-body > form {
  width: 100%;
  min-height: 100%;
}
.library-upload-view .card-body > form > .pos-relative {
  min-height: 100%;
}
.library-upload-view .card-body .row.is-clearfix {
  margin: 0;
}
.library-upload-view .card-body .content-tab {
  width: 100%;
  margin: 0;
  padding: 28px;
}
.library-upload-view .card-body .content-tab > .col,
.library-upload-view .card-body .content-tab > .col-md-6 {
  padding: 0 12px;
}
.library-upload-view {
}
.library-upload-view #lesson {
  max-width: 1200px;
  margin: 0 auto;
}
.library-upload-view #lesson > .col-md-6 {
  padding: 0 18px;
}
.library-upload-view #lesson .row {
  margin-left: -10px;
  margin-right: -10px;
}
.library-upload-view {
}
.library-upload-view .field {
  margin-bottom: 22px;
}
.library-upload-view .field .label {
  margin-bottom: 8px;
  color: var(--text);
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
}
.library-upload-view .field .required {
  margin-left: 2px;
  color: var(--danger);
}
.library-upload-view .control {
  width: 100%;
}
.library-upload-view .input,
.library-upload-view textarea,
.library-upload-view select {
  width: 100%;
  min-height: 42px;
  padding: 10px 13px;
  border: 1px solid #d0d5dd;
  border-radius: 9px;
  outline: none;
  background: #fff;
  color: var(--text);
  font-size: 14px;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;
}
.library-upload-view .input:hover,
.library-upload-view textarea:hover,
.library-upload-view select:hover {
  border-color: #b8c0cc;
}
.library-upload-view .input:focus,
.library-upload-view textarea:focus,
.library-upload-view select:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}
.library-upload-view .input::placeholder,
.library-upload-view textarea::placeholder,
.library-upload-view select::placeholder {
  color: #98a2b3;
}
.library-upload-view {
}
.library-upload-view .file-upload-container {
  width: 100%;
  margin-bottom: 24px;
}
.library-upload-view .upload-label {
  display: block;
  margin-bottom: 9px;
  color: var(--text);
  font-size: 13px;
  font-weight: 600;
}
.library-upload-view .upload-card {
  position: relative;
  width: 100%;
  min-height: 230px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px dashed #c7d2fe;
  border-radius: 14px;
  background:
    linear-gradient(
      180deg,
      #fafaff 0%,
      #f8faff 100%);
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    background 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
}
.library-upload-view .upload-card:hover {
  border-color: var(--primary);
  background: #f5f7ff;
  transform: translateY(-1px);
  box-shadow: 0 8px 20px rgba(79, 70, 229, 0.08);
}
.library-upload-view .upload-card.file-added {
  min-height: 83px;
  border-style: solid;
}
.library-upload-view .upload-placeholder {
  width: 100%;
  text-align: center;
}
.library-upload-view .upload-placeholder .upload-icon {
  width: 54px;
  height: 54px;
  margin: 0 auto 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: var(--primary-soft);
  color: var(--primary);
  font-size: 24px;
}
.library-upload-view .upload-placeholder .upload-title {
  margin: 0 0 7px;
  color: var(--text);
  font-size: 14px;
  font-weight: 600;
}
.library-upload-view .upload-placeholder .upload-subtitle {
  margin: 0 0 5px;
  color: var(--text-muted);
  font-size: 12px;
}
.library-upload-view .upload-placeholder .upload-size {
  margin: 0;
  color: var(--text-light);
  font-size: 11px;
}
.library-upload-view .uploaded-file {
  width: 100%;
}
.library-upload-view .file-info {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 14px;
  border-radius: 10px;
}
.library-upload-view .file-info > .file-icon {
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  object-fit: contain;
}
.library-upload-view .file-details {
  min-width: 0;
  flex: 1;
}
.library-upload-view .file-name {
  margin: 0;
  overflow: hidden;
  color: var(--text);
  font-size: 13px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: 0;
}
.library-upload-view .remove-file {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  background: #fff1f0;
  color: var(--danger);
  cursor: pointer;
}
.library-upload-view .remove-file:hover {
  background: #fee4e2;
}
.library-upload-view {
}
.library-upload-view .responsiveRadioBtn {
  display: flex;
  align-items: center;
  min-height: 42px;
  padding: 10px 13px;
  border: 1px solid var(--border-light);
  border-radius: 9px;
  background: var(--surface-soft);
}
.library-upload-view .responsiveRadioBtn label {
  margin: 0 0 0 10px;
  color: var(--text);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
.library-upload-view {
}
.library-upload-view p-editor {
  display: block;
  width: 100%;
}
.library-upload-view p-editor .p-editor-container {
  overflow: hidden;
  border: 1px solid #d0d5dd;
  border-radius: 10px;
}
.library-upload-view p-editor .p-editor-container:focus-within {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}
.library-upload-view p-editor .p-editor-toolbar {
  border: 0;
  border-bottom: 1px solid var(--border-light);
  background: #f8fafc;
}
.library-upload-view p-editor .p-editor-content {
  border: 0;
}
.library-upload-view p-editor .p-editor-content .ql-editor {
  min-height: 170px;
  padding: 14px;
  color: var(--text);
  font-size: 14px;
  line-height: 1.6;
}
.library-upload-view {
}
.library-upload-view .questionnarie {
  position: relative;
  margin: 0 0 18px !important;
  padding: 20px;
  border: 1px solid var(--border-light);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 5px rgba(16, 24, 40, 0.03);
}
.library-upload-view .questionnarie:hover {
  border-color: #d8dce5;
  box-shadow: 0 5px 15px rgba(16, 24, 40, 0.05);
}
.library-upload-view .question-choice .label {
  margin-bottom: 9px;
}
.library-upload-view .radio-group {
  display: flex !important;
  flex-wrap: wrap;
  gap: 8px;
}
.library-upload-view .radio-group .radio {
  display: flex;
  align-items: center;
  padding: 7px 11px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
}
.library-upload-view .radio-group .radio:has(input:checked) {
  border-color: var(--primary);
  background: var(--primary-soft);
}
.library-upload-view .radio-group .radio input {
  margin: 0 6px 0 0;
  accent-color: var(--primary);
}
.library-upload-view .radio-group .radio .radio-label {
  margin: 0 !important;
  color: var(--text-muted);
  font-size: 12px;
  cursor: pointer;
}
.library-upload-view .question-option {
  padding: 15px;
  border: 1px solid var(--border-light);
  border-radius: 10px;
  background: var(--surface-soft);
}
.library-upload-view .question-option .control {
  margin-bottom: 9px;
}
.library-upload-view .removeAssQuestion,
.library-upload-view .removeOptions {
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  border-radius: 8px;
  color: #98a2b3 !important;
  cursor: pointer;
}
.library-upload-view .removeAssQuestion:hover,
.library-upload-view .removeOptions:hover {
  color: var(--danger) !important;
  background: #fff1f0;
}
.library-upload-view {
}
.library-upload-view .button {
  min-height: 38px;
  padding: 8px 15px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  background: #fff;
  color: var(--text);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.library-upload-view .button:hover {
  border-color: #b8c0cc;
  background: #f8fafc;
}
.library-upload-view .button.is-link {
  border-color: var(--primary);
  background: var(--primary);
  color: #fff;
}
.library-upload-view .button.is-link:hover {
  border-color: var(--primary-dark);
  background: var(--primary-dark);
  box-shadow: 0 4px 10px rgba(79, 70, 229, 0.2);
  transform: translateY(-1px);
}
.library-upload-view .button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}
.library-upload-view {
}
.library-upload-view .card-footer {
  flex: 0 0 auto;
  min-height: 68px;
  padding: 14px 24px;
  border-top: 1px solid var(--border-light);
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0 -4px 12px rgba(16, 24, 40, 0.03);
}
.library-upload-view .card-footer .row {
  width: 100%;
  margin: 0;
}
.library-upload-view .card-footer .lessonPublish {
  display: flex;
  align-items: center;
}
.library-upload-view .card-footer .lessonSubmitBtn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
}
.library-upload-view .has-text-danger {
  margin-top: 5px;
  color: var(--danger) !important;
  font-size: 11px;
}
.library-upload-view .scroll-bar {
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.library-upload-view .scroll-bar::-webkit-scrollbar {
  width: 6px;
}
.library-upload-view .scroll-bar::-webkit-scrollbar-track {
  background: transparent;
}
.library-upload-view .scroll-bar::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 20px;
}
.library-upload-view {
}
@media (max-width: 991.98px) {
  .library-upload-view .questionariesTab {
    padding: 16px;
  }
  .library-upload-view .card-body .content-tab {
    padding: 20px 16px;
  }
  .library-upload-view #lesson > .col-md-6 {
    width: 100%;
    padding: 0 8px;
  }
  .library-upload-view #lesson > .col-md-6 + .col-md-6 {
    margin-top: 10px;
  }
  .library-upload-view .upload-card {
    min-height: 210px;
  }
}
@media (max-width: 767.98px) {
  .library-upload-view .card {
    border: 0;
    border-radius: 0;
  }
  .library-upload-view .questionariesTab {
    padding: 14px 10px;
  }
  .library-upload-view .questionariesTab ul {
    justify-content: flex-start;
  }
  .library-upload-view .questionariesTab .tab {
    min-width: 130px;
    padding: 0 10px;
  }
  .library-upload-view .questionariesTab .tab > span:first-child {
    width: 30px;
    height: 30px;
    flex-basis: 30px;
  }
  .library-upload-view .questionariesTab .tab .line-horizontal {
    top: 15px;
    width: 30px;
  }
  .library-upload-view .questionariesTab .tab a {
    font-size: 12px;
  }
  .library-upload-view .card-body .content-tab {
    padding: 16px 12px;
  }
  .library-upload-view #lesson > .col-md-6 {
    padding: 0;
  }
  .library-upload-view .upload-card {
    min-height: 190px;
    padding: 20px;
  }
  .library-upload-view .upload-placeholder .upload-icon {
    width: 46px;
    height: 46px;
    font-size: 20px;
  }
  .library-upload-view .upload-placeholder .upload-title {
    font-size: 13px;
  }
  .library-upload-view .questionnarie {
    padding: 14px;
  }
  .library-upload-view .radio-group {
    gap: 5px;
  }
  .library-upload-view .radio-group .radio {
    padding: 6px 8px;
  }
  .library-upload-view .card-footer {
    padding: 10px 12px;
  }
  .library-upload-view .card-footer .lessonSubmitBtn {
    width: 100%;
    justify-content: flex-end;
  }
  .library-upload-view .card-footer .lessonPublish {
    display: none;
  }
}
@media (max-width: 480px) {
  .library-upload-view .questionariesTab .tab {
    min-width: 110px;
  }
  .library-upload-view .questionariesTab .tab a {
    font-size: 11px;
  }
  .library-upload-view .file-info {
    padding: 10px;
  }
  .library-upload-view .file-name {
    font-size: 12px;
  }
  .library-upload-view .card-footer .button {
    min-height: 36px;
    padding: 7px 12px;
    font-size: 12px;
  }
}
.assessment-tab {
  width: 100%;
  padding: 20px 0 40px;
  background: #f7f9fc;
}
.assessment-container {
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 20px;
}
.assessment-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
}
.assessment-header .assessment-eyebrow {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 5px;
  color: #253b80;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.assessment-header .assessment-eyebrow i {
  font-size: 13px;
}
.assessment-header h3 {
  margin: 0;
  color: #172033;
  font-size: 22px;
  font-weight: 700;
}
.assessment-header p {
  margin: 5px 0 0;
  color: #7b8496;
  font-size: 13px;
}
.question-count {
  min-width: 80px;
  padding: 10px 16px;
  border: 1px solid #e5e9f2;
  border-radius: 12px;
  background: #fff;
  text-align: center;
}
.question-count span {
  display: block;
  color: #4f46e5;
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.question-count small {
  display: block;
  margin-top: 4px;
  color: #8992a3;
  font-size: 11px;
}
.assessment-settings {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  margin-bottom: 20px;
}
.setting-card {
  position: relative;
  display: flex;
  gap: 13px;
  min-height: 112px;
  padding: 16px;
  border: 1px solid #e7eaf0;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 3px 12px rgba(24, 39, 75, 0.035);
  transition: 0.2s ease;
}
.setting-card:hover {
  border-color: #d8dcff;
  box-shadow: 0 7px 20px rgba(24, 39, 75, 0.06);
}
.setting-icon {
  display: flex;
  flex: 0 0 38px;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #f0f1ff;
  color: #5956e9;
}
.setting-icon i {
  font-size: 15px;
}
.setting-content {
  flex: 1;
}
.setting-content label {
  display: block;
  margin-bottom: 3px;
  color: #252b3a;
  font-size: 13px;
  font-weight: 700;
}
.setting-content .setting-description {
  display: block;
  margin-bottom: 10px;
  color: #929aaa;
  font-size: 11px;
}
.setting-input {
  position: relative;
  display: flex;
  align-items: center;
  max-width: 180px;
}
.setting-input .input {
  height: 34px;
  padding: 5px 35px 5px 10px;
  border: 1px solid #dfe3eb;
  border-radius: 8px;
  background: #fafbfc;
  box-shadow: none;
  color: #252b3a;
  font-size: 12px;
}
.setting-input .input:focus {
  border-color: #253b80;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.08);
}
.setting-input > span {
  position: absolute;
  right: 11px;
  color: #8d95a5;
  font-size: 12px;
  font-weight: 600;
}
.modern-switch {
  position: relative !important;
  display: inline-block !important;
  width: 42px !important;
  height: 23px;
  margin-top: 3px;
  cursor: pointer;
}
.modern-switch input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.switch-slider {
  position: absolute;
  inset: 0;
  border-radius: 30px;
  background: #dce1e9;
  cursor: pointer;
  transition: 0.25s;
}
.switch-slider::before {
  content: "";
  position: absolute;
  width: 17px;
  height: 17px;
  left: 3px;
  top: 3px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  transition: 0.25s;
}
.modern-switch input:checked + .switch-slider {
  background: #5b5ce2;
}
.modern-switch input:checked + .switch-slider::before {
  transform: translateX(19px);
}
.assessment-empty {
  padding: 45px 25px;
  border: 1px dashed #d9deea;
  border-radius: 16px;
  background: #fff;
  text-align: center;
}
.empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 58px;
  height: 58px;
  margin: 0 auto 15px;
  border-radius: 16px;
  background: #f0f1ff;
  color: #253b80;
}
.empty-icon i {
  font-size: 24px;
}
.assessment-empty h4 {
  margin: 0;
  color: #252b3a;
  font-size: 17px;
  font-weight: 700;
}
.assessment-empty > p {
  max-width: 540px;
  margin: 7px auto 22px;
  color: #8b94a5;
  font-size: 12px;
  line-height: 1.6;
}
.question-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
}
.btn-modern {
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 215px;
  padding: 10px 14px;
  border: 1px solid transparent;
  border-radius: 10px;
  cursor: pointer;
  text-align: left;
  transition: 0.2s ease;
}
.btn-modern .btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 34px;
  width: 34px;
  height: 34px;
  border-radius: 8px;
}
.btn-modern strong,
.btn-modern small {
  display: block;
}
.btn-modern strong {
  font-size: 12px;
  font-weight: 700;
}
.btn-modern small {
  margin-top: 2px;
  font-size: 10px;
  opacity: 0.7;
}
.btn-ai {
  border-color: #d9d8ff;
  background: #f7f6ff;
  color: #514bdc;
}
.btn-ai .btn-icon {
  background: #e8e7ff;
}
.btn-ai:hover {
  border-color: #aaa7ff;
  background: #f0efff;
  transform: translateY(-1px);
}
.btn-manual {
  border-color: #e1e5ec;
  background: #fff;
  color: #394052;
}
.btn-manual .btn-icon {
  background: #f0f2f6;
  color: #596273;
}
.btn-manual:hover {
  border-color: #c9ced9;
  background: #fafbfc;
  transform: translateY(-1px);
}
.action-or {
  color: #a0a7b5;
  font-size: 11px;
  font-weight: 700;
}
.questions-wrapper {
  margin-top: 20px;
}
.questions-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 12px;
}
.questions-header h4 {
  margin: 0;
  color: #252b3a;
  font-size: 16px;
  font-weight: 700;
}
.questions-header p {
  margin: 3px 0 0;
  color: #8c94a4;
  font-size: 11px;
}
.add-question-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 13px;
  border: 1px solid #5b5ce2;
  border-radius: 8px;
  background: #5b5ce2;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;
}
.add-question-btn:hover {
  background: #4b4ccf;
  transform: translateY(-1px);
}
.question-card {
  margin-bottom: 14px;
  overflow: hidden;
  border: 1px solid #e5e8ef;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 3px 15px rgba(25, 35, 60, 0.035);
}
.question-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 16px;
  border-bottom: 1px solid #edf0f4;
  background: #fafbfc;
}
.question-number {
  display: flex;
  align-items: center;
  gap: 10px;
}
.question-number > span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background: #ededff;
  color: #5754dd;
  font-size: 12px;
  font-weight: 700;
}
.question-number strong,
.question-number small {
  display: block;
}
.question-number strong {
  color: #303647;
  font-size: 12px;
}
.question-number small {
  margin-top: 2px;
  color: #929aaa;
  font-size: 10px;
}
.delete-question {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 31px;
  height: 31px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #a0a7b4;
  cursor: pointer;
  transition: 0.2s;
}
.delete-question:hover {
  background: #fff0f1;
  color: #e05260;
}
.question-meta {
  display: grid;
  grid-template-columns: 1fr 180px;
  gap: 20px;
  padding: 17px 18px 10px;
}
.meta-field label,
.field-label {
  display: block;
  margin-bottom: 7px;
  color: #353b4a;
  font-size: 11px;
  font-weight: 700;
}
.required {
  color: #e05260;
}
.question-types {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.question-type-option {
  position: relative;
  display: inline-flex !important;
  align-items: center;
  gap: 7px;
  margin: 0 !important;
  padding: 7px 11px;
  border: 1px solid #e1e5ec;
  border-radius: 8px;
  background: #fff;
  color: #687183 !important;
  cursor: pointer;
  font-size: 11px !important;
  font-weight: 600 !important;
  transition: 0.2s;
}
.question-type-option input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.question-type-option .type-radio {
  width: 13px;
  height: 13px;
  border: 1px solid #bbc1cd;
  border-radius: 50%;
  transition: 0.2s;
}
.question-type-option:hover {
  border-color: #aaa9ef;
}
.question-type-option.active {
  border-color: #6765e8;
  background: #f4f4ff;
  color: #5654d9 !important;
}
.question-type-option.active .type-radio {
  border: 4px solid #6366e1;
}
.mark-input {
  position: relative;
}
.mark-input .input {
  height: 36px;
  padding-right: 38px;
  border-color: #dfe3ea;
  border-radius: 8px;
  box-shadow: none;
  font-size: 12px;
}
.mark-input .input:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.07);
}
.mark-input > span {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #969dab;
  font-size: 10px;
  font-weight: 600;
}
.question-body {
  padding: 5px 18px 17px;
}
.question-input-wrapper {
  position: relative;
}
.question-input-wrapper .question-input {
  height: 42px;
  padding: 8px 12px;
  border: 1px solid #dfe3ea;
  border-radius: 9px;
  background: #fafbfc;
  box-shadow: none;
  color: #252b3a;
  font-size: 12px;
}
.question-input-wrapper .question-input::placeholder {
  color: #a5acb9;
}
.question-input-wrapper .question-input:focus {
  border-color: #253b80;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.07);
}
.answers-section {
  margin: 0 18px 18px;
  padding: 15px;
  border: 1px solid #e8ebf1;
  border-radius: 11px;
  background: #fafbfc;
}
.answers-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 9px;
}
.answers-header .field-label {
  margin-bottom: 2px;
}
.answers-header > div > span {
  color: #969eac;
  font-size: 10px;
}
.answer-count {
  padding: 4px 8px;
  border-radius: 20px;
  background: #eef0f5;
  color: #737b8b;
  font-size: 9px;
  font-weight: 600;
}
.answer-row {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) auto 30px;
  align-items: start;
  gap: 9px;
  margin-bottom: 8px;
}
.option-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 35px;
  border-radius: 7px;
  background: #f0f2f6;
  color: #7e8797;
  font-size: 10px;
  font-weight: 700;
}
.answer-input-wrapper .input {
  height: 35px;
  border-color: #e0e4eb;
  border-radius: 8px;
  background: #fff;
  box-shadow: none;
  font-size: 11px;
}
.answer-input-wrapper .input:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.06);
}
.correct-answer {
  display: flex !important;
  align-items: center;
  gap: 6px;
  height: 35px;
  margin: 0 !important;
  padding: 0 9px;
  border: 1px solid #e0e4eb;
  border-radius: 8px;
  background: #fff;
  color: #858d9d !important;
  cursor: pointer;
  font-size: 10px !important;
  font-weight: 600 !important;
  white-space: nowrap;
}
.correct-answer input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.correct-answer .correct-radio {
  width: 13px;
  height: 13px;
  border: 1px solid #c0c5ce;
  border-radius: 50%;
}
.correct-answer.selected {
  border-color: #54b983;
  background: #f0fbf5;
  color: #28945e !important;
}
.correct-answer.selected .correct-radio {
  border: 4px solid #39a86c;
}
.correct-answer .correct-label i {
  display: none;
}
.correct-answer.selected .correct-label i {
  display: inline-block;
}
.remove-answer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 35px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #a2a9b6;
  cursor: pointer;
}
.remove-answer:hover {
  background: #fff0f1;
  color: #dc5361;
}
.add-answer-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 2px;
  padding: 7px 10px;
  border: 1px dashed #c8cce0;
  border-radius: 7px;
  background: transparent;
  color: #5957d8;
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
}
.add-answer-btn:hover {
  border-color: #7673e8;
  background: #f4f4ff;
}
.validation-message {
  margin-top: 4px;
  color: #df5965;
  font-size: 10px;
}
.correct-answer-error {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 6px 0 9px;
  color: #dc5964;
  font-size: 10px;
}
.questions-footer {
  display: flex;
  justify-content: center;
  padding: 6px 0 15px;
}
.add-question-outline {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 15px;
  border: 1px dashed #bfc3d9;
  border-radius: 8px;
  background: #fff;
  color: #5c5bd8;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s;
}
.add-question-outline:hover {
  border-color: #6967e5;
  background: #f7f7ff;
}
.assessment-tab input.input {
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.assessment-tab button {
  outline: none;
}
@media (max-width: 1100px) {
  .assessment-settings {
    grid-template-columns: 1fr 1fr;
  }
  .question-meta {
    grid-template-columns: 1fr;
  }
  .mark-field {
    max-width: 200px;
  }
}
@media (max-width: 768px) {
  .assessment-container {
    padding: 0 12px;
  }
  .assessment-header {
    align-items: flex-start;
  }
  .assessment-header h3 {
    font-size: 19px;
  }
  .assessment-settings {
    grid-template-columns: 1fr;
  }
  .questions-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .add-question-btn {
    width: 100%;
    justify-content: center;
  }
  .question-types {
    flex-direction: column;
  }
  .question-type-option {
    width: 100%;
  }
  .answer-row {
    grid-template-columns: 28px minmax(0, 1fr) 30px;
  }
  .answer-row .correct-answer {
    grid-column: 2;
    width: fit-content;
  }
  .answer-row .remove-answer {
    grid-column: 3;
    grid-row: 1;
  }
}
@media (max-width: 520px) {
  .assessment-tab {
    padding-top: 10px;
  }
  .assessment-header .question-count {
    display: none;
  }
  .assessment-empty {
    padding: 30px 15px;
  }
  .question-actions {
    flex-direction: column;
  }
  .btn-modern {
    width: 100%;
  }
  .action-or {
    margin: -3px 0;
  }
  .question-card-header,
  .question-meta,
  .question-body {
    padding-left: 12px;
    padding-right: 12px;
  }
  .answers-section {
    margin-left: 12px;
    margin-right: 12px;
    padding: 10px;
  }
  .answer-row {
    grid-template-columns: 26px minmax(0, 1fr) 28px;
    gap: 6px;
  }
  .option-number {
    width: 26px;
  }
  .correct-answer {
    grid-column: 2;
    max-width: 100%;
  }
}
.survey-tab {
  width: 100%;
  padding: 20px 0 40px;
  background: #f7f9fc;
}
.survey-container {
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 20px;
}
.survey-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
}
.survey-header .survey-eyebrow {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 5px;
  color: #253b80;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.survey-header .survey-eyebrow i {
  font-size: 13px;
}
.survey-header h3 {
  margin: 0;
  color: #172033;
  font-size: 22px;
  font-weight: 700;
}
.survey-header p {
  margin: 5px 0 0;
  color: #7b8496;
  font-size: 13px;
}
.survey-count {
  min-width: 80px;
  padding: 10px 16px;
  border: 1px solid #e5e9f2;
  border-radius: 12px;
  background: #fff;
  text-align: center;
}
.survey-count span {
  display: block;
  color: #5b5ce2;
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.survey-count small {
  display: block;
  margin-top: 4px;
  color: #8992a3;
  font-size: 11px;
}
.survey-empty {
  padding: 48px 25px;
  border: 1px dashed #d9deea;
  border-radius: 16px;
  background: #fff;
  text-align: center;
}
.survey-empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  margin: 0 auto 15px;
  border-radius: 16px;
  background: #f0f1ff;
  color: #5b5ce2;
}
.survey-empty-icon i {
  font-size: 25px;
}
.survey-empty h4 {
  margin: 0;
  color: #252b3a;
  font-size: 17px;
  font-weight: 700;
}
.survey-empty p {
  max-width: 500px;
  margin: 7px auto 20px;
  color: #8b94a5;
  font-size: 12px;
  line-height: 1.6;
}
.survey-primary-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 15px;
  border: 1px solid #5b5ce2;
  border-radius: 8px;
  background: #5b5ce2;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
}
.survey-primary-btn:hover {
  background: #4d4ecf;
  transform: translateY(-1px);
  box-shadow: 0 5px 12px rgba(91, 92, 226, 0.2);
}
.survey-questions {
  margin-top: 20px;
}
.survey-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 12px;
}
.survey-section-header h4 {
  margin: 0;
  color: #252b3a;
  font-size: 16px;
  font-weight: 700;
}
.survey-section-header p {
  margin: 3px 0 0;
  color: #8c94a4;
  font-size: 11px;
}
.survey-add-question-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 13px;
  border: 1px solid #5b5ce2;
  border-radius: 8px;
  background: #5b5ce2;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
}
.survey-add-question-btn:hover {
  background: #4c4dcc;
  transform: translateY(-1px);
}
.survey-question-card {
  overflow: hidden;
  margin-bottom: 14px;
  border: 1px solid #e5e8ef;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 3px 15px rgba(25, 35, 60, 0.035);
}
.survey-question-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 16px;
  border-bottom: 1px solid #edf0f4;
  background: #fafbfc;
}
.survey-question-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.survey-question-title > div strong,
.survey-question-title > div small {
  display: block;
}
.survey-question-title > div strong {
  color: #303647;
  font-size: 12px;
}
.survey-question-title > div small {
  margin-top: 2px;
  color: #929aaa;
  font-size: 10px;
}
.survey-question-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background: #ededff;
  color: #5754dd;
  font-size: 12px;
  font-weight: 700;
}
.survey-delete-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 31px;
  height: 31px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #a0a7b4;
  cursor: pointer;
  transition: 0.2s ease;
}
.survey-delete-btn:hover {
  background: #fff0f1;
  color: #e05260;
}
.survey-question-body {
  padding: 18px;
}
.survey-field-label {
  display: block;
  margin-bottom: 7px;
  color: #353b4a;
  font-size: 11px;
  font-weight: 700;
}
.required {
  color: #e05260;
}
.survey-question-input .input {
  width: 100%;
  height: 42px;
  padding: 8px 12px;
  border: 1px solid #dfe3ea;
  border-radius: 9px;
  background: #fafbfc;
  box-shadow: none;
  color: #252b3a;
  font-size: 12px;
  transition: 0.2s ease;
}
.survey-question-input .input::placeholder {
  color: #a5acb9;
}
.survey-question-input .input:focus {
  border-color: #253b80;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.07);
  outline: none;
}
.survey-answers {
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #e8ebf1;
  border-radius: 11px;
  background: #fafbfc;
}
.survey-answers-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}
.survey-answers-header .survey-field-label {
  margin-bottom: 2px;
}
.survey-answers-header > div > span {
  color: #969eac;
  font-size: 10px;
}
.survey-option-count {
  padding: 4px 8px;
  border-radius: 20px;
  background: #eef0f5;
  color: #737b8b;
  font-size: 9px;
  font-weight: 600;
}
.survey-answer-row {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) 32px;
  align-items: start;
  gap: 9px;
  margin-bottom: 8px;
}
.survey-option-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 35px;
  border-radius: 7px;
  background: #f0f2f6;
  color: #7e8797;
  font-size: 10px;
  font-weight: 700;
}
.survey-answer-input .input {
  width: 100%;
  height: 35px;
  border: 1px solid #e0e4eb;
  border-radius: 8px;
  background: #fff;
  box-shadow: none;
  color: #303647;
  font-size: 11px;
  transition: 0.2s ease;
}
.survey-answer-input .input::placeholder {
  color: #a5acb9;
}
.survey-answer-input .input:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.06);
  outline: none;
}
.survey-remove-answer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 35px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #a2a9b6;
  cursor: pointer;
  transition: 0.2s ease;
}
.survey-remove-answer:hover {
  background: #fff0f1;
  color: #dc5361;
}
.survey-add-option {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 2px;
  padding: 7px 10px;
  border: 1px dashed #c8cce0;
  border-radius: 7px;
  background: transparent;
  color: #5957d8;
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
}
.survey-add-option:hover {
  border-color: #7673e8;
  background: #f4f4ff;
}
.survey-validation {
  margin-top: 4px;
  color: #df5965;
  font-size: 10px;
}
.survey-footer {
  display: flex;
  justify-content: center;
  padding: 6px 0 15px;
}
.survey-add-question-outline {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 15px;
  border: 1px dashed #bfc3d9;
  border-radius: 8px;
  background: #fff;
  color: #5c5bd8;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
}
.survey-add-question-outline:hover {
  border-color: #6967e5;
  background: #f7f7ff;
}
@media (max-width: 768px) {
  .survey-container {
    padding: 0 12px;
  }
  .survey-header {
    align-items: flex-start;
  }
  .survey-header h3 {
    font-size: 19px;
  }
  .survey-section-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .survey-add-question-btn {
    width: 100%;
    justify-content: center;
  }
  .survey-question-body {
    padding: 14px;
  }
  .survey-answers {
    padding: 12px;
  }
}
@media (max-width: 520px) {
  .survey-tab {
    padding-top: 10px;
  }
  .survey-count {
    display: none;
  }
  .survey-empty {
    padding: 32px 15px;
  }
  .survey-answer-row {
    grid-template-columns: 26px minmax(0, 1fr) 30px;
    gap: 6px;
  }
  .survey-option-number {
    width: 26px;
  }
  .survey-answer-input {
    min-width: 0;
  }
  .survey-remove-answer {
    width: 30px;
  }
  .survey-answers-header {
    align-items: flex-start;
    flex-direction: column;
  }
}
.poll-tab {
  width: 100%;
  padding: 20px 0 40px;
  background: #f7f9fc;
}
.poll-container {
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 20px;
}
.poll-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
}
.poll-header .poll-eyebrow {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 5px;
  color: #253b80;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.poll-header .poll-eyebrow i {
  font-size: 13px;
}
.poll-header h3 {
  margin: 0;
  color: #172033;
  font-size: 22px;
  font-weight: 700;
}
.poll-header p {
  margin: 5px 0 0;
  color: #7b8496;
  font-size: 13px;
}
.poll-count {
  min-width: 80px;
  padding: 10px 16px;
  border: 1px solid #e5e9f2;
  border-radius: 12px;
  background: #fff;
  text-align: center;
}
.poll-count span {
  display: block;
  color: #253b80;
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.poll-count small {
  display: block;
  margin-top: 4px;
  color: #8992a3;
  font-size: 11px;
}
.poll-empty {
  padding: 48px 25px;
  border: 1px dashed #d9deea;
  border-radius: 16px;
  background: #fff;
  text-align: center;
}
.poll-empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  margin: 0 auto 15px;
  border-radius: 16px;
  background: #eef0ff;
  color: #253b80;
}
.poll-empty-icon i {
  font-size: 25px;
}
.poll-empty h4 {
  margin: 0;
  color: #252b3a;
  font-size: 17px;
  font-weight: 700;
}
.poll-empty p {
  max-width: 520px;
  margin: 7px auto 20px;
  color: #8b94a5;
  font-size: 12px;
  line-height: 1.6;
}
.poll-primary-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 15px;
  border: 1px solid #253b80;
  border-radius: 8px;
  background: #253b80;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
}
.poll-primary-btn:hover {
  background: #5052d5;
  transform: translateY(-1px);
  box-shadow: 0 5px 12px rgba(99, 102, 241, 0.2);
}
.poll-questions {
  margin-top: 20px;
}
.poll-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 12px;
}
.poll-section-header h4 {
  margin: 0;
  color: #252b3a;
  font-size: 16px;
  font-weight: 700;
}
.poll-section-header p {
  margin: 3px 0 0;
  color: #8c94a4;
  font-size: 11px;
}
.poll-add-question-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 13px;
  border: 1px solid #253b80;
  border-radius: 8px;
  background: #253b80;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
}
.poll-add-question-btn:hover {
  background: #5052d5;
  transform: translateY(-1px);
}
.poll-question-card {
  overflow: hidden;
  margin-bottom: 14px;
  border: 1px solid #e5e8ef;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 3px 15px rgba(25, 35, 60, 0.035);
}
.poll-question-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 16px;
  border-bottom: 1px solid #edf0f4;
  background: #fafbfc;
}
.poll-question-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.poll-question-title strong,
.poll-question-title small {
  display: block;
}
.poll-question-title strong {
  color: #303647;
  font-size: 12px;
}
.poll-question-title small {
  margin-top: 2px;
  color: #929aaa;
  font-size: 10px;
}
.poll-question-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background: #ededff;
  color: #5754dd;
  font-size: 12px;
  font-weight: 700;
}
.poll-delete-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 31px;
  height: 31px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #a0a7b4;
  cursor: pointer;
  transition: 0.2s ease;
}
.poll-delete-btn:hover {
  background: #fff0f1;
  color: #e05260;
}
.poll-question-body {
  padding: 18px;
}
.poll-field-label {
  display: block;
  margin-bottom: 7px;
  color: #353b4a;
  font-size: 11px;
  font-weight: 700;
}
.required {
  color: #e05260;
}
.poll-question-input {
  position: relative;
}
.poll-question-input .input {
  width: 100%;
  height: 42px;
  padding: 8px 12px 8px 42px;
  border: 1px solid #dfe3ea;
  border-radius: 9px;
  background: #fafbfc;
  box-shadow: none;
  color: #252b3a;
  font-size: 12px;
  transition: 0.2s ease;
}
.poll-question-input .input::placeholder {
  color: #a5acb9;
}
.poll-question-input .input:focus {
  border-color: #253b80;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.07);
  outline: none;
}
.poll-question-prefix {
  position: absolute;
  z-index: 2;
  top: 7px;
  left: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 27px;
  height: 27px;
  border-radius: 7px;
  background: #ededff;
  color: #5b5bd9;
  font-size: 10px;
  font-weight: 700;
}
.poll-choices {
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #e8ebf1;
  border-radius: 11px;
  background: #fafbfc;
}
.poll-choices-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}
.poll-choices-header .poll-field-label {
  margin-bottom: 2px;
}
.poll-choices-header > div > span {
  color: #969eac;
  font-size: 10px;
}
.poll-choice-count {
  padding: 4px 8px;
  border-radius: 20px;
  background: #eef0f5;
  color: #737b8b;
  font-size: 9px;
  font-weight: 600;
}
.poll-choice-row {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr) 32px;
  align-items: start;
  gap: 9px;
  margin-bottom: 8px;
}
.poll-choice-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 35px;
  border-radius: 7px;
  background: #f0f2f6;
  color: #7e8797;
  font-size: 10px;
  font-weight: 700;
}
.poll-choice-input .input {
  width: 100%;
  height: 35px;
  border: 1px solid #e0e4eb;
  border-radius: 8px;
  background: #fff;
  box-shadow: none;
  color: #303647;
  font-size: 11px;
  transition: 0.2s ease;
}
.poll-choice-input .input::placeholder {
  color: #a5acb9;
}
.poll-choice-input .input:focus {
  border-color: #253b80;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.06);
  outline: none;
}
.poll-remove-choice {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 35px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #a2a9b6;
  cursor: pointer;
  transition: 0.2s ease;
}
.poll-remove-choice:hover {
  background: #fff0f1;
  color: #dc5361;
}
.poll-add-choice {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 2px;
  padding: 7px 10px;
  border: 1px dashed #c8cce0;
  border-radius: 7px;
  background: transparent;
  color: #5957d8;
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
}
.poll-add-choice:hover {
  border-color: #7673e8;
  background: #f4f4ff;
}
.poll-validation {
  margin-top: 4px;
  color: #df5965;
  font-size: 10px;
}
.poll-footer {
  display: flex;
  justify-content: center;
  padding: 6px 0 15px;
}
.poll-add-question-outline {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 15px;
  border: 1px dashed #bfc3d9;
  border-radius: 8px;
  background: #fff;
  color: #5c5bd8;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
}
.poll-add-question-outline:hover {
  border-color: #6967e5;
  background: #f7f7ff;
}
@media (max-width: 768px) {
  .poll-container {
    padding: 0 12px;
  }
  .poll-header {
    align-items: flex-start;
  }
  .poll-header h3 {
    font-size: 19px;
  }
  .poll-section-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .poll-add-question-btn {
    width: 100%;
    justify-content: center;
  }
  .poll-question-body {
    padding: 14px;
  }
  .poll-choices {
    padding: 12px;
  }
}
@media (max-width: 520px) {
  .poll-tab {
    padding-top: 10px;
  }
  .poll-count {
    display: none;
  }
  .poll-empty {
    padding: 32px 15px;
  }
  .poll-choice-row {
    grid-template-columns: 26px minmax(0, 1fr) 30px;
    gap: 6px;
  }
  .poll-choice-number {
    width: 26px;
  }
  .poll-choice-input {
    min-width: 0;
  }
  .poll-remove-choice {
    width: 30px;
  }
  .poll-choices-header {
    align-items: flex-start;
    flex-direction: column;
  }
}
.notes-tab {
  width: 100%;
  padding: 20px 0 40px;
  background: #f7f9fc;
}
.notes-container {
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  padding: 0 20px;
}
.notes-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
}
.notes-header-content .notes-eyebrow {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 5px;
  color: #f59e0b;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.notes-header-content .notes-eyebrow i {
  font-size: 13px;
}
.notes-header-content h3 {
  margin: 0;
  color: #172033;
  font-size: 22px;
  font-weight: 700;
}
.notes-header-content p {
  max-width: 700px;
  margin: 5px 0 0;
  color: #7b8496;
  font-size: 13px;
  line-height: 1.5;
}
.notes-count {
  min-width: 80px;
  padding: 10px 16px;
  border: 1px solid #e5e9f2;
  border-radius: 12px;
  background: #fff;
  text-align: center;
}
.notes-count span {
  display: block;
  color: #f59e0b;
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.notes-count small {
  display: block;
  margin-top: 4px;
  color: #8992a3;
  font-size: 11px;
}
.notes-empty {
  padding: 55px 25px;
  border: 1px dashed #d9deea;
  border-radius: 16px;
  background: #fff;
  text-align: center;
}
.notes-empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;
  border-radius: 16px;
  background: #fff6df;
  color: #f59e0b;
}
.notes-empty-icon i {
  font-size: 26px;
}
.notes-empty h4 {
  margin: 0;
  color: #252b3a;
  font-size: 17px;
  font-weight: 700;
}
.notes-empty p {
  max-width: 540px;
  margin: 7px auto 20px;
  color: #8b94a5;
  font-size: 12px;
  line-height: 1.6;
}
.notes-primary-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 15px;
  border: 1px solid #f59e0b;
  border-radius: 8px;
  background: #f59e0b;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
}
.notes-primary-btn:hover {
  background: #d98700;
  transform: translateY(-1px);
  box-shadow: 0 5px 12px rgba(245, 158, 11, 0.2);
}
.notes-content {
  margin-top: 20px;
}
.notes-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 12px;
}
.notes-section-header h4 {
  margin: 0;
  color: #252b3a;
  font-size: 16px;
  font-weight: 700;
}
.notes-section-header p {
  margin: 3px 0 0;
  color: #8c94a4;
  font-size: 11px;
}
.notes-add-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 13px;
  border: 1px solid #f59e0b;
  border-radius: 8px;
  background: #f59e0b;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
}
.notes-add-btn:hover {
  background: #d98700;
  transform: translateY(-1px);
}
.notes-card {
  overflow: hidden;
  margin-bottom: 14px;
  border: 1px solid #e5e8ef;
  border-radius: 15px;
  background: #fff;
  box-shadow: 0 3px 15px rgba(25, 35, 60, 0.035);
}
.notes-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 16px;
  border-bottom: 1px solid #edf0f4;
  background: #fafbfc;
}
.notes-card-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.notes-card-title strong,
.notes-card-title small {
  display: block;
}
.notes-card-title strong {
  color: #303647;
  font-size: 12px;
}
.notes-card-title small {
  margin-top: 2px;
  color: #929aaa;
  font-size: 10px;
}
.notes-number {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background: #fff4d9;
  color: #d88b00;
  font-size: 12px;
  font-weight: 700;
}
.notes-delete-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 31px;
  height: 31px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #a0a7b4;
  cursor: pointer;
  transition: 0.2s ease;
}
.notes-delete-btn:hover {
  background: #fff0f1;
  color: #e05260;
}
.notes-editor-wrapper {
  padding: 18px;
}
.notes-editor-label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 8px;
}
.notes-editor-label label {
  display: block;
  margin-bottom: 2px;
  color: #353b4a;
  font-size: 11px;
  font-weight: 700;
}
.notes-editor-label > div > span {
  display: block;
  color: #969eac;
  font-size: 10px;
}
.required {
  color: #e05260;
}
.notes-editor-type {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 8px;
  border-radius: 6px;
  background: #f5f6f8;
  color: #7d8594;
  font-size: 9px;
  font-weight: 600;
  white-space: nowrap;
}
.notes-editor-type i {
  font-size: 9px;
}
.notes-editor :host ::ng-deep .p-editor-container {
  overflow: hidden;
  border: 1px solid #dfe3ea;
  border-radius: 10px;
  background: #fff;
  transition: 0.2s ease;
}
.notes-editor :host ::ng-deep .p-editor-toolbar {
  border: 0;
  border-bottom: 1px solid #e8ebf0;
  background: #fafbfc;
  padding: 7px 9px;
}
.notes-editor :host ::ng-deep .p-editor-content {
  border: 0;
  background: #fff;
}
.notes-editor :host ::ng-deep .ql-editor {
  min-height: 170px;
  padding: 13px 15px;
  color: #303647;
  font-size: 12px;
  line-height: 1.65;
}
.notes-editor :host ::ng-deep .ql-editor.ql-blank::before {
  left: 15px;
  color: #a5acb9;
  font-size: 12px;
  font-style: normal;
  content: "Write your notes here...";
}
.notes-editor :host ::ng-deep .ql-toolbar .ql-picker,
.notes-editor :host ::ng-deep .ql-toolbar button {
  color: #687181;
}
.notes-editor :host ::ng-deep .ql-toolbar button:hover,
.notes-editor :host ::ng-deep .ql-toolbar button.ql-active {
  color: #d88b00;
}
.notes-editor :host ::ng-deep .p-editor-container:focus-within {
  border-color: #f59e0b;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.07);
}
.notes-validation {
  margin-top: 5px;
  color: #df5965;
  font-size: 10px;
}
.notes-footer {
  display: flex;
  justify-content: center;
  padding: 6px 0 15px;
}
.notes-add-outline {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 15px;
  border: 1px dashed #c9c4a9;
  border-radius: 8px;
  background: #fff;
  color: #c27e00;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
}
.notes-add-outline:hover {
  border-color: #e0a32d;
  background: #fffaf0;
}
@media (max-width: 768px) {
  .notes-container {
    padding: 0 12px;
  }
  .notes-header {
    align-items: flex-start;
  }
  .notes-header-content h3 {
    font-size: 19px;
  }
  .notes-section-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .notes-add-btn {
    width: 100%;
    justify-content: center;
  }
  .notes-editor-wrapper {
    padding: 14px;
  }
}
@media (max-width: 520px) {
  .notes-tab {
    padding-top: 10px;
  }
  .notes-count {
    display: none;
  }
  .notes-empty {
    padding: 35px 15px;
  }
  .notes-editor-label {
    align-items: flex-start;
    flex-direction: column;
  }
  .notes-editor-type {
    align-self: flex-start;
  }
  .notes-card-header {
    padding: 11px 12px;
  }
}
/*# sourceMappingURL=e-library-upload.component.css.map */
